/**
 * router/index.ts
 *
 * Automatic routes for `./src/pages/*.vue`
 */

// Composables
import { setupAuthGuard } from '@/router/auth.guard';
import { setupLayouts } from 'virtual:generated-layouts';
import { createRouter, createWebHistory } from 'vue-router';
// @ts-ignore
import { routes } from 'vue-router/auto-routes';

// Create routes with layouts
const routesWithLayouts = setupLayouts(routes);

// Apply meta to specific routes
const routesWithMeta = routesWithLayouts.map((route) => {
  // Check if this is a route that needs specific meta
  if (route.path === '/Logout' || route.path === '/SystemError' || route.path === '/Info') {
    return {
      ...route,
      meta: {
        ...(route.meta || {}),
        requiresAuth: false,
      },
    };
  } else {
    return {
      ...route,
      meta: {
        ...(route.meta || {}),
        requiresAuth: true,
      },
    };
  }
});

const router = createRouter({
  history: createWebHistory((import.meta as any).env.BASE_URL),
  routes: [
    ...routesWithMeta,
    {
      path: '/',
      redirect: '/TopPage',
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: () => import('@/pages/LoginPage.vue'),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/logout',
      name: 'Logout',
      component: () => import('@/pages/Logout.vue'),
      meta: {
        requiresAuth: false,
        layout: 'default',
      },
    },
  ],
  // routes: custom_routes,
});

// Workaround for https://github.com/vitejs/vite/issues/11804
router.onError((err, to) => {
  if (err?.message?.includes?.('Failed to fetch dynamically imported module')) {
    if (!localStorage.getItem('vuetify:dynamic-reload')) {
      console.log('Reloading page to fix dynamic import error');
      localStorage.setItem('vuetify:dynamic-reload', 'true');
      location.assign(to.fullPath);
    } else {
      console.error('Dynamic import error, reloading page did not fix it', err);
    }
  } else {
    console.error(err);
  }
});

router.isReady().then(() => {
  localStorage.removeItem('vuetify:dynamic-reload');
});

setupAuthGuard(router);

export default router;
